import {
  Button,
  Grid,
  Modal,
  Pagination,
  Paper,
  Stack,
  Chip,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import InputField from "../FormComponents/InputField";
import SelectingTable from "../FormComponents/SelectingTable";
import { getImportBillData, getImportData } from "../services/Import";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export default function ImportBillSelectingPopup({
  setOpenTable,
  openTable,
  handleCloseTable,
  setSelectedItems,
  selectedItems,
  isOneChoise,
  skipList,
}) {
  const [page, setPage] = React.useState(0);
  const [rows, setRows] = React.useState([]);
  const [totalPages, setTotalPages] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [filter, setFilter] = useState({
    _billNo: "",
  });

  const handleFilterChange = (name, val) => {
    setFilter({
      ...filter,
      [name]: val,
    });
  };

  const resetFilters = () => {
    setFilter({
      _billNo: "",
    });
  };

  const handleChangepage = async (event, value) => {
    setPage(value - 1);
  };

  useEffect(() => {
    fetchData();
  }, [page, filter]);

  const fetchData = async () => {
    setOpenTable(true);
    let result = await getImportBillData(page, 10, filter);
    let importBillSet = result.content.filter(
      (item) => !skipList.includes(item.bill_id)
    );
    setTotalPages(result.totalPages);
    console.log("importBillSet", importBillSet);
    const newSet = importBillSet.map((item) => {
      return createDataForBills(
        item.billNo,
        item.addedBy,
        item[0],
        item.shop,
        item.bill_id
      );
    });
    setRows(newSet);
  };

  //columns for table
  const columns = [
    { id: "bill_num", label: "Bill No.", minWidth: 100 },
    { id: "added_by", label: "Added By", minWidth: 100 },
    { id: "date", label: "Date", minWidth: 100 },
    { id: "shop", label: "Shop", minWidth: 100 },
  ];

  //creating data for rows according to Id
  function createDataForBills(bill_num, added_by, date, shop, billId) {
    return { bill_num, added_by, date, shop, billId };
  }

  return (
    <Grid item xs={12} sm={9} sx={12} sx={{ mt: 2 }}>
      <Modal
        keepMounted
        open={openTable}
        onClose={handleCloseTable}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Paper sx={style}>
          <Grid container>
            <Grid item xs={12} sm={12} sx={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4} sx={12}>
                  <InputField
                    name="_billNo"
                    value={filter._billNo}
                    onChange={(event, newInputValue) =>
                      handleFilterChange(event, newInputValue)
                    }
                    type="text"
                    label="Bill Number"
                  />
                </Grid>
                <Grid item xs={12} sm={4} sx={12}>
                  <Stack direction="row" spacing={2}>
                    <Button
                      variant="contained"
                      onClick={() => {
                        resetFilters();
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => {
                        fetchData();
                      }}
                    >
                      Filter
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} sx={12}>
              <SelectingTable
                isOneChoise={isOneChoise}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                title="Import Items"
                columns={columns}
                rows={rows}
                setSelected={setSelectedItems}
                selected={selectedItems}
                _key="billId"
                setOpenTable={setOpenTable}
                handleCloseTable={handleCloseTable}
              />
            </Grid>

            <Stack spacing={3}>
              <Pagination
                count={totalPages}
                variant="outlined"
                shape="rounded"
                size="small"
                onChange={handleChangepage}
              />
            </Stack>
          </Grid>
        </Paper>
      </Modal>
    </Grid>
  );
}
